function compile(data) {
    return 'No results found';
}

export default compile;
